'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parserPipe;

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trim(value) {
  return typeof value === 'string' ? _ramda2.default.trim(value) : value;
}

function shouldBeNull(value) {
  if (_ramda2.default.isNil(value)) return true;
  if (value === '') return true;
  return false;
}

function parserPipe(parser) {
  return _ramda2.default.pipe(trim, _ramda2.default.ifElse(shouldBeNull, _ramda2.default.always(null), parser));
}


//////////////////
// WEBPACK FOOTER
// ./~/coact/utils/makeParser/parserPipe.js
// module id = 1741
// module chunks = 0